import dynamic from 'next/dynamic'
import { ErrorBoundary } from '../src/components/ErrorBoundary'

const ContactPage = dynamic(() => import('../src/pages/ContactPage'), {
  ssr: false,
})

export default function Contact() {
  return (
    <ErrorBoundary>
      <ContactPage />
    </ErrorBoundary>
  )
}